module.exports = __webpack_public_path__ + "static/grid-039c02206636cf9ec6e0087a8014b176.png";